module.exports = __webpack_public_path__ + "Luciana.66e637e63ee62a5b9102.png";


//////////////////
// WEBPACK FOOTER
// D:/inetpub/wwwroot/kaizen-ng/src/assets/images/Luciana.png
// module id = ../../../../../src/assets/images/Luciana.png
// module chunks = main